/** Stable fingerprint for guest-list–relevant dashboard payload changes. */
export function dashboardListFingerprint(data) {
  if (!data) return "";

  const counts = data.counts || {};
  const rsvpSig = (data.rsvps || [])
    .map((r) => [
      r.id,
      r.dancer_id,
      r.attendance_status,
      r.role,
      r.first_timer ? 1 : 0,
      r.hide_name ? 1 : 0,
      (r.dance_forms || []).map((d) => `${d.name}:${d.level}`).join(","),
    ].join(":"))
    .join("|");

  const inviteSig = (data.invite_requests || [])
    .map((r) => r.id || r.dancer_id || "")
    .join("|");

  return [
    counts.total ?? 0,
    counts.balanced_leaders ?? 0,
    counts.balanced_followers ?? 0,
    data.waitlisted ?? 0,
    data.event_status ?? "",
    data.lifecycle ?? "",
    data.balance_message ?? "",
    rsvpSig,
    inviteSig,
  ].join(";");
}

export function dashboardListChanged(previous, next) {
  if (!previous || !next) return Boolean(next);
  return dashboardListFingerprint(previous) !== dashboardListFingerprint(next);
}

export function restoreWindowScroll(scrollY) {
  if (scrollY == null) return;
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      window.scrollTo({ top: scrollY, left: 0, behavior: "auto" });
    });
  });
}
